import {
  OperationSummaryError,
  OperationSummaryParams
} from 'components/RecordsListView/types';
import useOperationSummary from 'hooks/useOperationSummary';
import useApplication, { ApplicationSummary } from './useApplication';

interface UseApplicationsSummaryReturn {
  loading: boolean;
  applications: ApplicationSummary[];
  totalElements: number;
  totalPages: number;
  pageSize: number;
  currentPage: number;
  numberOfElements: number;
  loadApplications: () => Promise<void>;
  errors?: OperationSummaryError | null;
  /** Crop seasons the held rows were fetched for; undefined until the first response. */
  loadedCropSeasonIds?: string[];
}

const useApplicationsSummary = (
  params?: OperationSummaryParams
): UseApplicationsSummaryReturn => {
  const { getSummaryApplications } = useApplication();

  const {
    loading,
    items: applications,
    totalElements,
    totalPages,
    pageSize,
    currentPage,
    numberOfElements,
    loadItems: loadApplications,
    errors,
    loadedCropSeasonIds
  } = useOperationSummary<ApplicationSummary>(
    'applicationsSummary',
    getSummaryApplications,
    params,
    'applicationsSummary'
  );

  return {
    loading,
    applications,
    totalElements,
    totalPages,
    pageSize,
    currentPage,
    numberOfElements,
    loadApplications,
    errors,
    loadedCropSeasonIds
  };
};

export default useApplicationsSummary;
